export const ADD_CREDITCARD = "ADD_CREDITCARD";
export const GET_CREDITCARDS = "GET_CREDITCARDS";